import React, { useState, useEffect } from 'react';
import sound from '../assets/images/mixkit-melodic-airport-announcement-ding-1570.wav'

export const Bell = () => {

  useEffect(() => {
    let sound = document.getElementById('sound')
    sound.play()
  }, []);

  return <audio preload='auto' src={sound} id='sound'/>
}